export class assigneeMapping {
    CLIENT_ID: number;
    ID: number;
    TYPE: number;
    REFERENCE_ID: number;
    ASSIGNEE_ID: any;
    REPORTER_ID: number;
    STATUS: string;
}